const LOGO_ROOT = '/provider-logos/herkulbet131';

const PROVIDER_LOGO_FILES = [
  '1x2gaming.webp',
  '3oaks.webp',
  '4theplayer.png',
  '77gaming.webp',
  'alg.png',
  'amusnet.webp',
  'aspectgaming.png',
  'avatarux.webp',
  'Aviatrix.webp',
  'Belatra.webp',
  'BetGames.webp',
  'BetSoft.webp',
  'Betsolutions.webp',
  'BFGames.webp',
  'bigpot.webp',
  'bigtime.webp',
  'boominggames.webp',
  'Caleta.webp',
  'cozmo.png',
  'CTInteractive.webp',
  'darpha.png',
  'egt-digital.webp',
  'endorphina.svg',
  'Espresso.webp',
  'EurasianGaming.webp',
  'evo.webp',
  'EvoPlay.webp',
  'exa.avif',
  'Ezugi.webp',
  'Fazi.webp',
  'fbastards.webp',
  'felix.png',
  'formulaspin.webp',
  'Fugaso.webp',
  'funta.svg',
  'galaxsys.webp',
  'GameArt.webp',
  'gamzix.svg',
  'gmw.png',
  'Habanero.webp',
  'hacksaw.webp',
  'InBet.webp',
  'imaginelive.webp',
  'irondog.webp',
  'jdb.svg',
  'kagaming.svg',
  'Kalamba.webp',
  'livevegas.webp',
  'LuckyStreak.webp',
  'maxwin.png',
  'MrSlotty.webp',
  'netent.webp',
  'NetGame.webp',
  'NINJAGAMING.png',
  'nolimit.webp',
  'novomatic.webp',
  'NucleusGaming.webp',
  'Onetouch.webp',
  'onlyplaylogo.webp',
  'orbital.webp',
  'petersons.png',
  'PGSoft.webp',
  'Platipus.webp',
  'Playson.webp',
  'popiplay.png',
  'pragmaticplay.svg',
  'Qora.png',
  'redrake.webp',
  'redtiger.webp',
  'RubyPlay.webp',
  'sagaming.svg',
  'slotmatrix.png',
  'slotopia.webp',
  'SmartSoft.webp',
  'SpadeGaming.webp',
  'spino.webp',
  'Swintt.webp',
  'TaDa.webp',
  'tapking.avif',
  'thunderspin.webp',
  'Tombala.webp',
  'tomhorn.svg',
  'TripleCherry.webp',
  'vivo.webp',
  'wazdan.webp',
  'yggdrasil.svg',
  'zillion.png',
];

/** Sağlayıcı adını yazım, boşluk ve ayraç farklarından arındırır. */
export const normalizeProviderName = (value) => String(value || '')
  .normalize('NFKD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '');

const LOGO_BY_NAME = Object.fromEntries(PROVIDER_LOGO_FILES.map((file) => {
  const basename = file.replace(/\.[^.]+$/, '');
  return [normalizeProviderName(basename), file];
}));

// Kataloglarda aynı marka servis ve ürün ekiyle gelebiliyor. Yalnızca bilinen
// eş anlamlılar bağlanır; benzer ama farklı sağlayıcıları bulanık eşleştirmeyiz.
const PROVIDER_ALIASES = {
  betsofta: 'betsoft',
  bigtimegaminga: 'bigtime',
  caletagaming: 'caleta',
  egt: 'egtdigital',
  evolution: 'evo',
  evolutionwc: 'evo',
  evolutionwchs: 'evo',
  evolutionwcls: 'evo',
  evolutionwcx: 'evo',
  evolutionwcy: 'evo',
  ezugix: 'ezugi',
  ezugiz: 'ezugi',
  hacksawopenrgs: 'hacksaw',
  imaginelivehs: 'imaginelive',
  imaginelivels: 'imaginelive',
  irondogpp: 'irondog',
  netentwc: 'netent',
  onlyplay: 'onlyplaylogo',
  pocketgamessoft: 'pgsoft',
  pragmatic: 'pragmaticplay',
  pragmaticbj: 'pragmaticplay',
  pragmaticbj2: 'pragmaticplay',
  pragmaticlive: 'pragmaticplay',
  redtigerwc: 'redtiger',
  tadagaming: 'tada',
  wazdana: 'wazdan',
  yggdrasila: 'yggdrasil',
};

/** Slug veya görünen adla eşleşen gömülü logonun site içi adresini döndürür. */
export const defaultProviderLogo = (...values) => {
  for (const value of values) {
    const name = normalizeProviderName(value);
    const file = LOGO_BY_NAME[PROVIDER_ALIASES[name] || name];
    if (file) return `${LOGO_ROOT}/${file}`;
  }
  return '';
};

/** `/game-providers` yanıtını ad, slug ve varsayılan logoyla tek biçime sokar. */
export const providersFromResponse = (response, limit = 22) => {
  const source = Array.isArray(response?.providers)
    ? response.providers
    : (response?.items || []).map((slug) => ({ slug, name: slug, logo: '' }));

  return source
    .map((provider) => {
      if (typeof provider === 'string') {
        return {
          slug: provider,
          name: provider,
          logo: defaultProviderLogo(provider),
        };
      }
      const slug = String(provider?.slug || provider?.name || '').trim();
      const name = String(provider?.name || slug).trim();
      return {
        ...provider,
        slug,
        name,
        // Panelden yüklenen/adres olarak girilen logo her zaman varsayılanın
        // önündedir; alan temizlenirse isim eşleşmesi yeniden devreye girer.
        logo: provider?.logo || defaultProviderLogo(slug, name),
      };
    })
    .filter((provider) => provider.slug && provider.name)
    .slice(0, limit);
};

export default defaultProviderLogo;
